import { useCallback, useEffect, useState } from "react";

const AUTH_KEY = "auth";

function safeParseAuth() {
    try {
        const raw = localStorage.getItem(AUTH_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export default function useActiveProfile() {
    const [authData, setAuthData] = useState(() => safeParseAuth());

    const refresh = useCallback(() => {
        setAuthData(safeParseAuth());
    }, []);

    // Updates when another tab changes localStorage
    useEffect(() => {
        const onStorage = (e) => {
            if (e.key === AUTH_KEY) refresh();
        };
        window.addEventListener("storage", onStorage);
        return () => window.removeEventListener("storage", onStorage);
    }, [refresh]);

    const profiles = authData?.user?.profiles || [];

    const activeProfile =
        profiles.find((p) => p?.activeInWeb === true) ||
        profiles[0] ||
        null;

    return { activeProfile, profiles, refresh, authData };
}
